var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 115,
    viewBox: "0 0 111 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.661 13.9489L27.4732 22.5736C15.7978 25.702 10.8318 34.3597 13.9705 46.0734L24.6008 85.7466C27.791 97.6523 36.3794 102.513 48.0547 99.3851L80.2426 90.7604C92.1061 87.5815 96.9213 79.1289 93.7312 67.2231L83.1008 27.55C79.9621 15.8362 71.5246 10.77 59.661 13.9489Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.6348,
    y: 85.5449,
    width: 51.3486,
    height: 43.4826,
    rx: 14,
    transform: "rotate(-105 37.6348 85.5449)",
    fill: "#8237FF",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.9296 34.4785H56.6063C44.5191 34.4785 37.4814 41.5559 37.4814 53.6829V94.7555C37.4814 107.081 44.5191 114 56.6063 114H89.9296C102.212 114 109.05 107.081 109.05 94.7555V53.6829C109.05 41.5559 102.212 34.4785 89.9296 34.4785Z",
    fill: "#BA90FF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9296 33.9785H56.6063C50.4655 33.9785 45.5435 35.7782 42.1568 39.1803C38.7704 42.5821 36.9814 47.5234 36.9814 53.6829V94.7555C36.9814 101.012 38.7694 105.965 42.1576 109.353C45.5457 112.741 50.4685 114.5 56.6063 114.5H89.9296C96.1629 114.5 101.086 112.742 104.451 109.352C107.814 105.962 109.55 101.009 109.55 94.7555V53.6829C109.55 47.5272 107.813 42.5852 104.452 39.1817C101.089 35.7772 96.166 33.9785 89.9296 33.9785Z",
    stroke: "url(#paint1_linear)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6796 52.9688V53.0085C55.9659 53.0085 54.5782 54.4001 54.5782 56.1098C54.5782 57.8195 55.9659 59.2112 57.6796 59.2112H69.564C71.2777 59.2112 72.6693 57.8195 72.6693 56.0661C72.6693 54.3604 71.2777 52.9688 69.564 52.9688H57.6796ZM88.8518 77.1836H57.6796C55.9659 77.1836 54.5782 75.792 54.5782 74.0823C54.5782 72.3726 55.9659 70.977 57.6796 70.977H88.8518C90.5615 70.977 91.9532 72.3726 91.9532 74.0823C91.9532 75.792 90.5615 77.1836 88.8518 77.1836ZM88.8522 95.3539H57.6799C56.4871 95.513 55.334 94.9165 54.6978 93.9225C54.0617 92.8888 54.0617 91.5767 54.6978 90.5826C55.334 89.5489 56.4871 88.9922 57.6799 89.1115H88.8522C90.4386 89.2705 91.6354 90.6224 91.6354 92.2526C91.6354 93.839 90.4386 95.1949 88.8522 95.3539Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6796 52.9688V53.0085C55.9659 53.0085 54.5782 54.4001 54.5782 56.1098C54.5782 57.8195 55.9659 59.2112 57.6796 59.2112H69.564C71.2777 59.2112 72.6693 57.8195 72.6693 56.0661C72.6693 54.3604 71.2777 52.9688 69.564 52.9688H57.6796ZM88.8518 77.1836H57.6796C55.9659 77.1836 54.5782 75.792 54.5782 74.0823C54.5782 72.3726 55.9659 70.977 57.6796 70.977H88.8518C90.5615 70.977 91.9532 72.3726 91.9532 74.0823C91.9532 75.792 90.5615 77.1836 88.8518 77.1836ZM88.8522 95.3539H57.6799C56.4871 95.513 55.334 94.9165 54.6978 93.9225C54.0617 92.8888 54.0617 91.5767 54.6978 90.5826C55.334 89.5489 56.4871 88.9922 57.6799 89.1115H88.8522C90.4386 89.2705 91.6354 90.6224 91.6354 92.2526C91.6354 93.839 90.4386 95.1949 88.8522 95.3539Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6796 53.0085V53.4085H58.0796V53.0085H57.6796ZM57.6796 52.9688V52.5687H57.2796V52.9688H57.6796ZM57.6799 95.3539V94.9539H57.6533L57.627 94.9574L57.6799 95.3539ZM88.8522 95.3539V95.7539H88.8722L88.8921 95.7519L88.8522 95.3539ZM54.6978 93.9225L54.3571 94.1322L54.3609 94.1382L54.6978 93.9225ZM54.6978 90.5826L55.0348 90.7983L55.0385 90.7923L54.6978 90.5826ZM57.6799 89.1115L57.6401 89.5095L57.6599 89.5115H57.6799V89.1115ZM88.8522 89.1115L88.8921 88.7135L88.8722 88.7115H88.8522V89.1115ZM58.0796 53.0085V52.9688H57.2796V53.0085H58.0796ZM54.9782 56.1098C54.9782 54.6207 56.1871 53.4085 57.6796 53.4085V52.6085C55.7446 52.6085 54.1782 54.1796 54.1782 56.1098H54.9782ZM57.6796 58.8112C56.1871 58.8112 54.9782 57.599 54.9782 56.1098H54.1782C54.1782 58.0401 55.7446 59.6112 57.6796 59.6112V58.8112ZM69.564 58.8112H57.6796V59.6112H69.564V58.8112ZM72.2693 56.0661C72.2693 57.602 71.0535 58.8112 69.564 58.8112V59.6112C71.5019 59.6112 73.0693 58.0371 73.0693 56.0661H72.2693ZM69.564 53.3688C71.0574 53.3688 72.2693 54.582 72.2693 56.0661H73.0693C73.0693 54.1388 71.4979 52.5687 69.564 52.5687V53.3688ZM57.6796 53.3688H69.564V52.5687H57.6796V53.3688ZM57.6796 77.5836H88.8518V76.7836H57.6796V77.5836ZM54.1782 74.0823C54.1782 76.0126 55.7446 77.5836 57.6796 77.5836V76.7836C56.1871 76.7836 54.9782 75.5714 54.9782 74.0823H54.1782ZM57.6796 70.577C55.744 70.577 54.1782 72.1527 54.1782 74.0823H54.9782C54.9782 72.5925 56.1878 71.377 57.6796 71.377V70.577ZM88.8518 70.577H57.6796V71.377H88.8518V70.577ZM92.3532 74.0823C92.3532 72.1524 90.7831 70.577 88.8518 70.577V71.377C90.34 71.377 91.5532 72.5929 91.5532 74.0823H92.3532ZM88.8518 77.5836C90.7825 77.5836 92.3532 76.0129 92.3532 74.0823H91.5532C91.5532 75.5711 90.3406 76.7836 88.8518 76.7836V77.5836ZM57.6799 95.7539H88.8522V94.9539H57.6799V95.7539ZM54.3609 94.1382C55.0734 95.2514 56.3727 95.9318 57.7327 95.7504L57.627 94.9574C56.6014 95.0942 55.5946 94.5817 55.0347 93.7069L54.3609 94.1382ZM54.3609 90.367C53.639 91.495 53.6435 92.9724 54.3572 94.1322L55.0385 93.7129C54.4798 92.8051 54.4843 91.6583 55.0347 90.7983L54.3609 90.367ZM57.7197 88.7135C56.3768 88.5792 55.0749 89.2067 54.3572 90.373L55.0385 90.7923C55.5931 89.891 56.5973 89.4052 57.6401 89.5095L57.7197 88.7135ZM88.8522 88.7115H57.6799V89.5115H88.8522V88.7115ZM92.0354 92.2526C92.0354 90.4245 90.6904 88.8938 88.8921 88.7135L88.8123 89.5095C90.1868 89.6473 91.2354 90.8203 91.2354 92.2526H92.0354ZM88.8921 95.7519C90.6876 95.5719 92.0354 94.0398 92.0354 92.2526H91.2354C91.2354 93.6383 90.1896 94.8178 88.8123 94.9559L88.8921 95.7519Z",
    fill: "url(#paint3_linear)",
    mask: "url(#path-5-inside-1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0.487671,
    y: 0.834793,
    width: 103.005,
    height: 108.567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b",
    x: 12.4814,
    y: 9.47852,
    width: 121.569,
    height: 129.521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd",
    x: 39.2207,
    y: 37.9688,
    width: 67.7325,
    height: 72.4107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.577356 0 0 0 0 0.359375 0 0 0 0 0.9375 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 43.5652,
    y1: 18.2617,
    x2: 64.1468,
    y2: 95.0732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F66FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 48.8741,
    y1: 43.7428,
    x2: 100.461,
    y2: 101.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 89.278,
    y1: 60.6273,
    x2: 47.2383,
    y2: 61.8468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 60.2271,
    y1: 57.9097,
    x2: 87.7722,
    y2: 88.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.5a2dc9c72efc201ba397641039a224f7.svg";
export { ForwardRef as ReactComponent };